import { IProjectData } from "@droid/project-interface"

export const projectUtils = {
    getProjectName: (project?: IProjectData):string => {
        return project?.localName || project?.name || project?.id.slice(project?.id.length - 8) || ''
    }
}

